import { render, staticRenderFns } from "./MedicalPaymentBreakdown.vue?vue&type=template&id=6a50ae1e&scoped=true&"
import script from "./MedicalPaymentBreakdown.vue?vue&type=script&lang=js&"
export * from "./MedicalPaymentBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./MedicalPaymentBreakdown.vue?vue&type=style&index=0&id=6a50ae1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a50ae1e",
  null
  
)

export default component.exports